import '../css/tags.css';
import { onComponentView, normalizeComponent } from './tag-manager/gtm';

jQuery(document).ready(function() {
    if (product && typeof product === 'object') {
        onComponentView(normalizeComponent(product, 'product'));
    }
})
